import { useRouter } from 'next/router';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { media } from '@myrealtrip/modash';
import { callNativeHandler } from '@myrealtrip/marketing-log';
import { NavigationTitle, Icon, Text, UnstyledButton } from '@myrealtrip/web-ui';

import { MRT_ORIGIN } from '~config/publicEnv';
import { SEARCH_HOME_TITLE_HEIGHT } from '~constants/common';
import { useDetermineMobile, useWebView } from '@myrealtrip/device-detect';

const SearchHeader = () => {
  const { back, push } = useRouter();

  const isMobile = useDetermineMobile();
  const { isWebView } = useWebView();

  const handleClickGoBack = () => {
    back();
  };

  const handleCloseSearch = () => {
    if (isWebView) {
      try {
        callNativeHandler('close');
      } catch (error) {
        window.close();
      }
    } else {
      push(MRT_ORIGIN);
    }
  };

  return (
    <CustomNavigationTitle
      type={isWebView ? 'oneDepth' : 'global'}
      height={isMobile || isWebView ? SEARCH_HOME_TITLE_HEIGHT : 50}
      justify="flex-start"
      leftGroup={
        !isWebView &&
        isMobile && (
          <Button onClick={handleClickGoBack}>
            <Icon name="IcoArrowLeft" />
          </Button>
        )
      }
      rightGroup={
        isWebView && (
          <Button onClick={handleCloseSearch}>
            <Icon name="IcoClose" />
          </Button>
        )
      }
    >
      <TitleText
        typography={isMobile ? 'headlineNormal22' : 'headlineBold26'}
        as="h1"
        addLeftMargin={!!isWebView}
      >
        유럽 열차
      </TitleText>
    </CustomNavigationTitle>
  );
};

const CustomNavigationTitle = styled(NavigationTitle)`
  ${media.minMobile} {
    padding: 0;
    padding-bottom: 16px;
  }
`;

const Button = styled(UnstyledButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;

  & svg {
    fill: ${({ theme }) => theme.colors.gray.s1000};
  }
`;

const TitleText = styled(Text)<{ addLeftMargin: boolean }>`
  color: ${({ theme }) => theme.colors.gray.s1000};

  ${({ addLeftMargin }) =>
    addLeftMargin &&
    css`
      margin-left: 12px;
    `}
`;

export default SearchHeader;
